/* istanbul ignore file */
export * from './ProductHintsCard';
